import { FC } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { useRpPayoutsForm } from './useRpPayoutsForm'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { TRpPayoutsFormData } from './schema'
import { WrapDrawerCreateForm } from '../index'
import RpPayoutsFormBase from './base'
import { CreateRpPayoutPayload } from '../../prp2boxApi/payouts'
import { Prp2boxApiPayouts } from '../../prp2boxApi'

const RpPayoutsFormCreate: FC = () => {
  const queryClient = useQueryClient()
  const hookForm = useRpPayoutsForm()

  const createMutation = useMutation((payload: CreateRpPayoutPayload) => Prp2boxApiPayouts.create(payload), {
    onSuccess: () => {
      toast.success('Список выплат успешно создан')
      queryClient.invalidateQueries([EQueryKeysConstant.RP_PAYOUTS])
    },
  })

  const handleSave = (data: TRpPayoutsFormData) => {
    createMutation.mutate(data)
  }

  return (
    <WrapDrawerCreateForm title="Создание списка выплат" onSave={hookForm.handleSubmit(handleSave)}>
      <RpPayoutsFormBase hookForm={hookForm} />
    </WrapDrawerCreateForm>
  )
}

export default RpPayoutsFormCreate
